goog.provide('el8.appshared.feedItemActions');

goog.require('el8.appchart.dialog.addDiscreteLabValues');
goog.require('el8.appchart.dialog.addEditProblem');
goog.require('el8.appchart.dialog.editReportDetails');
goog.require('el8.appchart.dialog.ordermed.document');
goog.require('el8.appchart.dialog.refaxLetter');
goog.require('el8.appchart.dialog.reports');
goog.require('el8.appchart.letters.dialog.updateUnreadAlertNotification');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.mgr.orderForm');
// goog.require('el8.appchart.mgr.thirdpane'); - bizarre circular dependency
goog.require('el8.appchart.refpanel.confidential');
goog.require('el8.appchart.refpanel.history');
goog.require('el8.apphome.dialog.patientCheckin');
goog.require('el8.appshared.dialog.reassignPatient');
goog.require('el8.appshared.dialog.reassignReviewUser');
goog.require('el8.appshared.message');
goog.require('el8.data.practiceUsers');
goog.require('el8.model.identify');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.render.content');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.consts');
goog.require('el8.util.feed');



el8.appshared.feedItemActions = function(item, rType) {

    if (!item) { return null; }
    var menu = [];
    var isPatientFormCollection = el8.model.identify.isPatientFormCollection(item);

    if( el8.model.identify.isOrder( item ) ) {

        menu.push({
            actionText: 'Export to Note (Data)',
            actionFn: function( item ) {
                el8.appchart.mgr.notes.addReference({item: item});
            }
        });
        menu.push({
            actionText: 'Print Order',
            actionFn: function( item ) {
                var printPath = el8.service.urls.get('printOrder', [item]);
                if (el8Globals.APP === 'chart') {
                    el8.appchart.printService.open({
                        attachmentId: item.getId(),
                        url: printPath
                    });
                } else {
                    window.open(printPath);
                }
                return false;
            }
        });
        menu.push({
           actionText: 'Remove',
           actionFn: function( order ) {
                el8.uiwidget.deleteConfirm(
                    "order",
                    function() {
                        var orderType = order.getOrderType();
                        el8.ptdata[orderType+'Orders'].deleteItem(order);
                    }
                );
           }
        });

    } else if( el8.model.identify.isReport( item ) ) {
        menu.push({
            actionText: 'Edit Report Details',
            actionFn: function( item ) {
                el8.appchart.dialog.editReportDetails.show(item);
            }
        });
        menu.push({
            actionText: 'Add/Edit Tags',
            actionFn: function( item ) {
                el8.appchart.dialog.docTags.show({doc: item});
            }
        });
        menu.push({
            actionText: 'Print Report',
            actionFn: function( item ) {
                item.printReport();
            }
        });
        if( item.isSignedOff() && !isPatientFormCollection) {
            menu.push({
                actionText: 'Export to Note with Matched Prob (HPI & A)',
                actionFn: function(item) {
                    el8.appchart.mgr.notes.autoImportLabsProblems({
                        type: 'reports',
                        reportIds: [item.getId()]
                    });
                }
            });
            menu.push({
                actionText: 'Export to Note (HPI)',
                actionFn: function( item ) {
                    el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
                }
            });
            menu.push({
                actionText: 'Export to Note (HPI Sub-Bullet)',
                actionFn: function( item ) {
                    el8.appchart.mgr.notes.addProblemSubBullet(item);
                }
            });
            menu.push({
                actionText: 'Export to Note (Data)',
                actionFn: function( item ) {
                    el8.appchart.mgr.notes.addReference({item: item});
                }
            });
        }
        if (item.getReportType() === 'lab' && item.isAllowManualEdit()) {
            //only Labs without integrations should allow manual add
            menu.push({
                actionText: 'Add Lab Values For Trending',
                actionFn: function( item ) {
                    el8.appchart.dialog.addDiscreteLabValues.show(item.getId());
                }
            });
        }
        if (!isPatientFormCollection) {
            menu.push({
                actionText: 'Mark Previous Report As \"Partial\"',
                actionFn: function( item ) {
                    el8.render.content.renderPreviousReportAsPartial( item );
                }
            });
        }
        if ((item.getReportType() !== 'lab') || !item.hasGrids()) {
            menu.push({
                actionText: 'Append to Another Report',
                actionFn: function( item ) {
                    el8.render.content.renderMergeIntoReport( item );
                }
            });
        }
        menu.push({
            actionText: 'Re-File to Another Patient Chart',
            actionFn: function( item ) {
                el8.appshared.dialog.reassignPatient.show({
                    docId: item.getId()
                });
            }
        });
        if (!item.isSignedOff() && !el8.data.practiceUsers.isSinglePhysicianPractice()) {
            menu.push({
                actionText: 'Re-assign to Another Provider',
                actionFn: function( item ) {
                    el8.appshared.dialog.reassignReviewUser.show({
                        report: item,
                        successCb: function() {
                            el8.appchart.mainFeeds.reqAct.update();
                        }
                    });
                }
            });
        }
        menu.push({
            actionText: 'Remove',
            actionFn: function( item ) {
                item.deleteReport();
            }
        });
        if ((item.getReportType() !== 'lab') || !item.hasGrids()) {
            menu.push({
                actionText: 'Remove & Re-File Images',
                actionFn: function( item ) {
                    item.deleteReport(true);
                }
            });
        }

    } else if( el8.model.identify.isThread( item ) ) {

        if( !item.isReviewed() && item.isSignedOff() && item.getCurrMember() ) {
            menu.push({
                actionText: 'Acknowledge',
                actionFn: function( item ) {
                    el8.appshared.message.acknowledgeThread( item );
                }
            });
        }

        if( !item.isSignedOff() && item.getCurrMember() ) {
            menu.push({
                actionText: 'Reply',
                actionFn: function( item ) {
                    var cardContainer = $('#patient-feed-container');
                    el8.appshared.message.showReplyMessageForm( item, cardContainer );
                }
            });
        }

        if( !item.isReviewed() ) {
            // Add additional buttons
            menu.push({
                actionText: 'Write Rx Script',
                actionFn: function( item ) {
                    el8.appchart.mgr.orderForm.showMedsOrderForm();
                }
            });
            menu.push({
                actionText: 'Write Referral',
                actionFn: function( item ) {
                    el8.appchart.mgr.orderForm.showReferralOrderForm();
                }
            });
            menu.push({
                actionText: 'Write Lab Order',
                actionFn: function( item ) {
                    el8.appchart.mgr.orderForm.showLabOrderForm();
                }
            });
            menu.push({
                actionText: 'Write Imaging Order',
                actionFn: function( item ) {
                    el8.appchart.mgr.orderForm.showImagingOrderForm();
                }
            });
            menu.push({
                actionText: 'Write Cardiac Order',
                actionFn: function( item ) {
                    el8.appchart.mgr.orderForm.showCardiacOrderForm();
                }
            });
            menu.push({
                actionText: 'Write Sleep Order',
                actionFn: function( item ) {
                    el8.appchart.mgr.orderForm.showSleepOrderForm();
                }
            });
            menu.push({
                actionText: 'Write Pulmonary Order',
                actionFn: function( item ) {
                    el8.appchart.mgr.orderForm.showPulmonaryOrderForm();
                }
            });
        }

       menu.push({
           actionText: 'Print',
           actionFn: function( item ) {
               var printUrl = el8.service.urls.get('printMessageThread', [item, el8.ptdata.currPatient.getId()]);
               window.open(printUrl);
           }
       });
        menu.push({
           actionText: 'Remove',
           actionFn: function( item ) {
                el8.uiwidget.deleteConfirm(
                    "message thread",
                    function() { el8.ptdata.messageThreads.deleteItem(item); }
                );
           }
        });

    } else if( el8.model.identify.isDiscontinueMedOrder(item) ) {

        return el8.appchart.actions.dcMedOrder({item: item, chartFeed: true});

    } else if( el8.model.identify.isPrescription(item) ) {

        return el8.appchart.actions.medOrder({item: item, chartFeed: true});

    } else if ( el8.model.identify.isLetter(item) ) {

        if (item.isSignedOff()) {
            menu.push({
                actionText: 'Export to Note (Tx)',
                actionFn: function(item) {
                    el8.appchart.mgr.notes.addReference({item: item});
                }
            });
            menu.push({
                actionText: 'Export to Note (Data)',
                actionFn: function(item) {
                    el8.appchart.mgr.notes.addReference({item: item, sectionName: 'data'});
                }
            });

            if (item.isWithArchive()) {
                // withArchive -> if the ZIP exists, make it clear they won't be printing and if not,
                // don't let them try to download yet (but leave a placeholder action behind)
                if (item.isProcessed()) {
                    menu.push({
                        actionText: 'Download Archive',
                        actionFn: function(letter) { window.open(el8.service.urls.get('downloadZipLetter', [letter])); }
                    });
                } else {
                    menu.push({
                        actionSafeText: '<span class="disabled">Still Preparing Archive...</span>',
                        actionFn: function() { /* no-op */}
                    });
                }
            }

            if (item.isProcessed()) {
                menu.push({
                    actionText: 'Print Original',
                    actionFn: function(letter) { window.open(el8.service.urls.get('printPdfLetter', [letter])); }
                });
            } else {
                menu.push({
                    actionSafeText: '<span class="disabled">Still Preparing PDF...</span>',
                    actionFn: function() { /* no-op */}
                });
            }

            if (!item.isSendToPatient()) {
                menu.push({
                    actionText: 'Re-print Patient Copy',
                    actionFn: function(letter) {
                        window.open(el8.service.urls.get('printLetterPtCopy', [letter]));
                    }
                });
            }
            if (item.getFaxStatus()) {
                // should only be possible to re-fax letters that were previously faxed
                menu.push({
                    actionText: 'Re-Fax',
                    actionFn: function(letter) {
                        el8.appchart.dialog.refaxLetter.show(letter);
                    }
                });
            }
            menu.push({
                actionText: 'Write Message',
                actionFn: function(letter) {
                    el8.appshared.message.prePopulateNewMessage({
                        toDocId: letter.getId()
                    });
                }
            });
            menu.push({
                actionText: 'Remove',
                actionFn: function(letter) {
                    var deleteLetter = function() {
                        el8.ptdata.letters.deleteItem(letter);
                    };

                    el8.uiwidget.deleteConfirm(
                        "letter",
                        deleteLetter
                    );
                }
            });
        }

    } else if (item.is('LetterReceipt')) {
        if (item.isSignedOff() && !item.getFiledAsDocumentId() && !item.isPtLetter()) {
            menu.push({
                actionText: 'File as Consult Report',
                actionFn: function(receipt) {
                    receipt.fileReport(el8.util.consts.RECEIPT_BODY_ATTACHMENT);
                }
            });
        }
        menu.push({
            actionText: 'Write Message',
            actionFn: function(receipt) {
                el8.appshared.message.prePopulateNewMessage({
                    toDocId: receipt.getId()
                });
            }
        });
        if (item.isSignedOff() && !item.isPtLetter()) {
            menu.push({
                actionText: 'Reply to Provider',
                actionFn: function(receipt) {
                    var $receiptItem = el8.appchart.mainFeeds.chart.getRenderItem(receipt.getId());
                    $receiptItem.find('.letter-toggle-collapse-trigger').trigger('el8_expand');
                    $receiptItem.find('.comment-reply-trigger').click();
                    $(':input[name="replyBody"]', $receiptItem).focusFocus();
                }
            });
        }
        menu.push({
            actionText: 'Export to Note (Tx)',
            actionFn: function(receipt) {
                el8.appchart.mgr.notes.addReference({item: receipt});
            }
        });
        menu.push({
            actionText: 'Export to Note (Data)',
            actionFn: function(receipt) {
                el8.appchart.mgr.notes.addReference({item: receipt, sectionName: 'data'});
            }
        });
        menu.push({
            actionText: (item.isWithArchive()) ? 'Download Archive' : 'Print Original',
            actionFn: function(receipt) {
                window.open(el8.service.urls.get('printLetterReceipt', [receipt]));
            }
        });
        if (!item.isReferralLetter()) {
            menu.push({
                actionText: 'Remove',
                actionFn: function(receipt) {
                    el8.uiwidget.deleteConfirm(
                        "letter",
                        function() { el8.ptdata.letterReceipts.deleteItem(receipt); }
                    );
                }
            });
        }

    } else if (item.is('UnreadLetterNotification')) {
        menu.push({
            actionText: 'Acknowledge & Sign off',
            actionFn: function(item) {
                item.acknowledgeAndSignOff();
            }
        });
        menu.push({
            actionText: 'Notify me again later',
            actionFn: function(item) {
                el8.appchart.letters.dialog.updateUnreadAlertNotification.show(item);
            }
        });
        menu.push({
            actionText: 'Write Message',
            actionFn: function(item) {
                el8.appshared.message.prePopulateNewMessage({
                    toDocId: item.getLetter().getId()
                });
            }
        });
    } else if( el8.model.identify.isNonvisitNote( item ) ) {
        menu.push({
            actionText: 'Export to Note',
            actionFn: function( item ) {
                el8.appchart.mgr.notes.addReference({item: item});
            }
        });
        menu.push({
            actionText: 'Add/Edit Tags',
            actionFn: function( item ) {
                el8.appchart.dialog.docTags.show({doc: item});
            }
        });
        if (el8Globals.FEATURES.Letters) {
            menu.push({
                actionText: 'Send to Provider',
                actionFn: function( item ) {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.CONSULTANT_LETTER,
                        attachmentId: item.getId()
                    });
                }
            });
        }
        if (el8Globals.FEATURES.PatientPortal) {
            menu.push({
                actionText: 'Send to Patient',
                actionFn: function( item ) {
                    el8.appchart.mgr.thirdpane.attachToLetter({
                        type: el8.util.consts.PATIENT_LETTER,
                        attachmentId: item.getId()
                    });
                }
            });
        }
        menu.push({
            actionText: 'Print',
            actionFn: function(item) {
                el8.ptdata.nonvisitNotes.printNote(item);
            }
        });
        menu.push({
            actionText: 'Remove',
            actionFn: function( item ) {
                el8.uiwidget.deleteConfirm("note",
                    function() { el8.ptdata.nonvisitNotes.forceDeleteItem(item); }
                );
            }
        });
        if (item.getImages().length) {
            menu.push({
                actionText: 'Remove & Re-File Images',
                actionFn: function( item ) {
                    el8.uiwidget.deleteConfirm("note from the patient chart and send the images back to Incoming Documents",
                        function() { el8.ptdata.nonvisitNotes.deleteItemSendBackImages(item, false, true); }
                    );
                }
            });
        }

    } else if( el8.model.identify.isCheckout( item ) ) {
        menu.push({
            actionText: 'Acknowledge',
            actionFn: function( item ) {
                item.save( function() {
                    // Assumes it has chart feed item ID, and callbackFn is to remove this item
                    $('#' + el8.util.feed.getChartFeedItemId( item ) ).remove();
                });
            }
        });

    } else if(el8.model.identify.isPatientHistory(item)) {

        var historyItem = item;
        var itemId = historyItem.getId();
        var itemType = historyItem.getType();

        menu.push({
            actionText: 'Edit',
            actionFn : function() {
                el8.appchart.refpanel.history.editItem(itemId, itemType);
            }
        });
        menu.push({
            actionText: 'Export to Note',
            actionFn : function() {
                el8.util.amplitude.logEvent('export clinical profile history to note', {
                  section: itemType
                });
                el8.appchart.mgr.notes.addReference({item: historyItem });
            }
        });
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                el8.util.amplitude.logEvent('delete clinical profile history', {
                  section: itemType
                });
                el8.appchart.refpanel.history.removeItem(itemId, itemType);
            }
        });

    } else if (item.getModelClass() === 'PatientFamilyHistoryItem') {

        var familyItem = item;

        menu.push({
            actionText: 'Edit',
            actionFn : function() {
                el8.appchart.refpanel.family.editItem(familyItem.getId());
            }
        });
        menu.push({
            actionText: 'Export to Note',
            actionFn : function() {
                el8.appchart.mgr.notes.addReference({item: familyItem });
            }
        });
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                el8.appchart.refpanel.family.removeItem(familyItem.getId());
            }
        });

    } else if(el8.model.identify.isConfidentialItem(item)) {

        menu.push({
            actionText: 'Edit',
            actionFn : function() {
                var itemId = (item) ? item.getId() : null;
                el8.appchart.refpanel.confidential.editItem(itemId);
            }
        });
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                var itemId = (item) ? item.getId() : null;
                el8.appchart.refpanel.confidential.removeItem(itemId);
            }
        });

    } else if (item.is('DocumentAddendum')) {

        var itemId = item.getId();

        menu.push({
            actionText: 'Export to Note',
            actionFn : function() {
                el8.appchart.mgr.notes.addReference({item: item});
            }
        });
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                el8.uiwidget.deleteConfirm("addendum",
                    function() {
                        el8.ptdata.addendums.deleteItem(itemId);
                    }
                );
            }
        });

    } else if (item.is('RxHistoryDownloadSummary')) {

        menu.push({
            actionText: 'Export to Note (Data)',
            actionFn: function() {
                el8.appchart.mgr.notes.addReference({item: item});
            }
        });
        menu.push({
            actionText: 'Print',
            actionFn: function() {
                window.open(el8.service.urls.get('printRxHistoryDownloadSummary', [item.getId()]));
            }
        });

    } else if (item.is('XmlPatientSummary')) {
        menu.push({
            actionText: 'Download Original XML',
            actionFn: function(summary) {
                window.open(summary.getDownloadUrl());
            }
        });
        menu.push({
            actionText: 'Remove',
            actionFn: function(summary) {
                el8.uiwidget.deleteConfirm(
                    "item",
                    function() { el8.ptdata.xmlSummaries.deleteItem(summary); }
                );
            }
        });
    }

    return menu;

};
